<template>
  <div v-loading="loading"
       class="rank-chart-wrapper">
    <div class="rank-chart--title">
      关键词排名动态<span v-if="data" class="rank-chart--desc">(监控关键词数量：{{data.monitorKeywordQuantity}})</span>
    </div>
    <el-row>
      <el-col :span="8">
        <div ref="upChart" class="rank-chart--chart"></div>
      </el-col>
      <el-col :span="8">
        <div ref="noChart" class="rank-chart--chart"></div>
      </el-col>
      <el-col :span="8">
        <div ref="downChart" class="rank-chart--chart"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {isMeaningful} from "@/utils/common";

  export default {
    name: "app-ad-keyword-rank-pie",
    props: {
      data: {
        required: true
      },
      loading: {
        type: Boolean,
        default: false,
        required: true
      }
    },
    data() {
      return {
        chart: {
          up: null,
          no: null,
          down: null,
        },
      }
    },
    watch: {
      data: {
        handler: function (data) {
          if (isMeaningful(data)) {
            this.data = data;
            if (this.chart.up && this.chart.no && this.chart.down) {
              this.renderData(data);
            } else {
              this.cacheData = data;
            }
          } else {
            this.renderData([]);
          }
        }
      }
    },
    mounted() {
      this.renderChart('排名上升', 'up', "#0099ff");
      this.renderChart('排名稳定', 'no', "#51d351");
      this.renderChart('排名下降', 'down', "#fec03d");
      if (this.cacheData) {
        this.renderData(this.cacheData);
        this.cacheData = null;
      }
    },
    methods: {
      renderChart(chartTitle, chartName, qtyColor) {
        const chartRef = this.$refs[`${chartName}Chart`];
        if (chartRef) {
          this.chart[chartName] = this.$echarts.init(chartRef);
          const option = {
            color: [qtyColor, "#e9e9e9"],
            legend: false,
            title: {
              text: chartTitle,
              left: 'center',
              bottom: '5%',
              textStyle: {
                fontSize: 12
              }
            },
            graphic: {
              type: "text",
              left: "center",
              top: "35%",
              style: {
                text: '',
                textAlign: "center",
                fill: "#333",
                fontSize: 14,
                fontWeight: 600,
              }
            },
            series: [
              {
                type: 'pie',
                radius: ['40%', '60%'],
                center: ['50%', '40%'],
                silent: true,
                avoidLabelOverlap: false,
                hoverAnimation: false,
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '30',
                    fontWeight: 'bold'
                  }
                },
                labelLine: {
                  show: false
                },
                data: []
              }
            ]
          };
          this.chart[chartName].setOption(option);
          window.addEventListener("resize", () => {
            this.chart[chartName].resize();
          });
          this.$on('hook:destroyed', () => {
            window.removeEventListener("resize", function () {});
          });
        }
      },
      renderData(data) {
        // 上升数量
        this.chart.up.setOption({
          graphic: {
            style: {
              text: data.upTrendKeywordQuantity
            }
          },
          series: {
            data: [data.upTrendKeywordQuantity, data.monitorKeywordQuantity - data.upTrendKeywordQuantity],
          }
        });
        // 稳定数量
        this.chart.no.setOption({
          graphic: {
            style: {
              text: data.noTrendKeywordQuantity
            }
          },
          series: {
            data: [data.noTrendKeywordQuantity, data.monitorKeywordQuantity - data.noTrendKeywordQuantity],
          }
        });
        // 下降数量
        this.chart.down.setOption({
          graphic: {
            style: {
              text: data.downTrendKeywordQuantity
            }
          },
          series: {
            data: [data.downTrendKeywordQuantity, data.monitorKeywordQuantity - data.downTrendKeywordQuantity],
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "common";
</style>
